import { ITongHopHocPhiRequest } from "../../reducer-model/tong-hop/ITongHopHocPhiReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTongHopHocPhiActionsObj = {
  CHANGE_FILTER: {} as any,

  EXPORT_EXCEL_START: {} as ITongHopHocPhiRequest,
  EXPORT_EXCEL_SUCCESS: "",
  EXPORT_EXCEL_ERROR: "",
};

export const eTongHopHocPhiActionIds = generateActionTypeIds(
  eTongHopHocPhiActionsObj,
  "TONG_HOP_HOC_PHI"
);
export type ITongHopHocPhiActions = IGenericActionType<
  typeof eTongHopHocPhiActionsObj,
  "TONG_HOP_HOC_PHI"
>;
